module.exports = __webpack_public_path__ + "static/media/BlackWidow.6148dd76.jpg";